// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"b47d671d","197":"47919c9a","453":"c9fa93a2"}[chunkId] + ".chunk.js";
};